<!-- <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)"> -->
<!-- <mat-tab label="Mappa"> -->
<ebw-monorepo-rischio-analitico-filtri
  [opzioniComune]="opzioniComune"
  [opzioniTipologia]="opzioniTipologia"
  [opzioniAnaliti]="opzioniAnaliti"
  [poligonoAttivo]="poligonoAttivo"
  (applica)="onFiltriApplica($event)"
  (reset)="onFiltriReset()"
  (disegnaPoligono)="onDisegnaPoligono()"
  (rimuoviPoligono)="onRimuoviPoligono()"
>
</ebw-monorepo-rischio-analitico-filtri>
<!-- </mat-tab> -->
<!-- <mat-tab label="Riepilogo">
    <div class="mt-2">
      <ebw-monorepo-rischio-analitico-riepilogo [heatmap]="heatmap" [riepilogo]="riepilogo"></ebw-monorepo-rischio-analitico-riepilogo>
    </div>
  </mat-tab> -->
<!-- </mat-tab-group> -->
